module.exports = __webpack_public_path__ + "static/elephant6-ed6365ad61c368126e67ea12053298e8.jpeg";